import { render, staticRenderFns } from "./yssqProcess.vue?vue&type=template&id=d048566a&scoped=true&"
import script from "./yssqProcess.vue?vue&type=script&lang=js&"
export * from "./yssqProcess.vue?vue&type=script&lang=js&"
import style0 from "./yssqProcess.vue?vue&type=style&index=0&id=d048566a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d048566a",
  null
  
)

export default component.exports